import React, {lazy, Suspense, useEffect, useState} from 'react'
import {Route, Routes, useLocation} from 'react-router-dom'
import {LoanProvider} from '../context/LoanProvider'
import {Box, CircularProgress} from "@mui/material";

/*
*  [Component Code-Splitting] ¬ Load On-Demand
*  IMPORTANT!
*  React.lazy() expects a function that returns a promise resolving to a
*  module with a DEFAULT EXPORT!!!
*
*/
const Navbar = lazy(() => import("../components/Navbar/Main"))
const Footer = lazy(() => import("../components/Footer/Main"))
const Home = lazy(() => import("../components/Home/Main"))
const Home2 = lazy(() => import("../components/Home2/Main"))
const Team = lazy(() => import("../components/About/Team/Main"))
const TeamDetails = lazy(() => import("../components/About/TeamDetails/Main"))
const Service = lazy(() => import("../components/Services/Service/Main"))
const ServiceDetails = lazy(() => import("../components/Services/ServiceDetails/Main"))
const NewsMain = lazy(() => import("../components/News/NewsMain/Main"))
const NewsDetails = lazy(() => import("../components/News/NewsDetails/Main"))
const Work = lazy(() => import("../components/Pages/Work/Main"))
const LoanCalculator = lazy(() => import("../components/Pages/LoanCalculator/Main"))
const CreditCard = lazy(() => import("../components/Credit/CreditCard/Main"))
const CreditCardDetails = lazy(() => import("../components/Credit/CreditCardDetails/Main"))
const FAQ = lazy(() => import("../components/Pages/FAQ/Main"))
const Testimonials = lazy(() => import("../components/Pages/Testimonial/Main"))
const Contact = lazy(() => import("../components/Contact/Main"))


const Routing = () => {
    const [homePage, setHomePage] = useState(false);
    const location = useLocation();
    useEffect(() => {
        if (location.pathname === "/home-02") {
            setHomePage(false);
        } else {
            setHomePage(true);
        }
    }, [location]);

    return (
        <>
            <LoanProvider>
                <Suspense fallback={
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '100vh', // Ensures it takes full height of the screen
                        }}
                    >
                        <CircularProgress
                            aria-label="...loading"
                            color="secondary"
                            size="7rem"
                            sx={{
                                position: "static",
                                left: "50%",
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2
                            }}
                            thickness={4}
                        />
                    </Box>
                }>
                    {homePage && <Navbar/>}
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/home-02" element={<Home2/>}/>
                        <Route path="/team" element={<Team/>}/>
                        <Route path="/team-details" element={<TeamDetails/>}/>
                        <Route path="/service" element={<Service/>}/>
                        <Route path="/service-details" element={<ServiceDetails/>}/>
                        <Route path="/news-main" element={<NewsMain/>}/>
                        <Route path="/news-details" element={<NewsDetails/>}/>
                        <Route path="/work" element={<Work/>}/>
                        <Route path="/loan-calculator" element={< LoanCalculator/>}/>
                        <Route path="/credit-card" element={< CreditCard/>}/>
                        <Route path="/credit-card-details" element={< CreditCardDetails/>}/>
                        <Route path="/faqs" element={<FAQ/>}/>
                        <Route path="/testimonial" element={<Testimonials/>}/>
                        <Route path="/contact" element={<Contact/>}/>
                    </Routes>
                    <Footer/>
                </Suspense>
            </LoanProvider>
        </>
    )
}

export default Routing